import type { FC, PropsWithChildren } from "react";
import { CssBaseline, ThemeProvider } from "@mui/material";
import { ReactQueryDevtools } from "@tanstack/react-query-devtools";
import { useAtom } from "jotai";
import FabButton from "src/business-components/FabButton/FabButton";
import DefinityTourProvider from "src/business-components/onboarding/DefinityTourProvider/DefinityTourProvider";
import { useProvideDebugMode } from "src/hooks/useDebugMode";
import { ConfirmationModal } from "@components/ConfirmationModal/ConfirmationModal.tsx";
import { appPortalAtom } from "@components/utils/AppPortal/AppPortal.atoms.ts";
import { useMode } from "@theme";
import { useShareWithTenant } from "./AppProviders.hooks.ts";

export const AppProviders: FC<PropsWithChildren> = ({ children }) => {
  const theme = useMode();

  useProvideDebugMode();
  useShareWithTenant();

  const [, setAppPortal] = useAtom(appPortalAtom);

  return (
    <ThemeProvider theme={theme}>
      <CssBaseline />
      <DefinityTourProvider>{children}</DefinityTourProvider>
      <FabButton />
      <ConfirmationModal />
      {process.env.NODE_ENV === "development" &&
        !window.localStorage.getItem("is_e2e") && (
          <div
            style={{
              position: "fixed",
              bottom: "40px",
              left: "10px",
              zIndex: 9999,
            }}
          >
            <ReactQueryDevtools
              initialIsOpen={false}
              buttonPosition="relative"
              position="bottom"
            />
          </div>
        )}
      <div
        ref={(e) => {
          setAppPortal(e);
        }}
      ></div>
    </ThemeProvider>
  );
};
